import { apiCall, API_CONFIG } from './api';

const normalizeReelPagination = (pagination = {}, limit = 20) => {
  const currentPage = pagination.currentPage ?? pagination.page ?? 1;
  const totalPages = Math.max(
    1,
    pagination.totalPages ?? pagination.pages ?? 1,
  );
  const totalCount = pagination.totalCount ?? pagination.total ?? 0;
  return {
    currentPage,
    totalPages,
    totalCount,
    limit: pagination.limit ?? limit,
    hasNext:
      pagination.hasNext !== undefined
        ? pagination.hasNext
        : currentPage < totalPages,
    hasPrev:
      pagination.hasPrev !== undefined
        ? pagination.hasPrev
        : currentPage > 1,
  };
};

const mapReelListResponse = (response, limit = 20) => {
  if (!response?.success) {
    return response;
  }
  return {
    ...response,
    data: response.data || [],
    pagination: normalizeReelPagination(response.pagination, limit),
  };
};

export const reelAPI = {
  // Create reel
  createReel: async (reelData) => {
    try {
      const formData = new FormData();

      if (reelData.video instanceof File) {
        formData.append('video', reelData.video);
      }

      if (reelData.thumbnail instanceof File) {
        formData.append('thumbnail', reelData.thumbnail);
      }

      formData.append("title", reelData.title);
      formData.append('isActive', reelData.isActive !== undefined ? reelData.isActive : true);
      if (reelData.productId) formData.append('productId', reelData.productId);

      return await apiCall(API_CONFIG.ENDPOINTS.REEL_VIDEO_CREATE, {
        method: 'POST',
        body: formData
      });
    } catch (error) {
      console.error('Error creating reel:', error);
      throw error;
    }
  },

  // Get active reels
  getActiveReels: async (page = 1, limit = 20) => {
    try {
      const queryParams = new URLSearchParams();

      if (page) queryParams.append('page', page);
      if (limit) queryParams.append('limit', limit);

      const response = await apiCall(
        `${API_CONFIG.ENDPOINTS.REEL_VIDEO_ACTIVE}?${queryParams.toString()}`,
        { method: 'GET' }
      );

      return mapReelListResponse(response, limit);
    } catch (error) {
      console.error('Error fetching active reels:', error);
      throw error;
    }
  },

  // Get inactive reels
  getInactiveReels: async (page = 1, limit = 20) => {
    try {
      const queryParams = new URLSearchParams();

      if (page) queryParams.append('page', page);
      if (limit) queryParams.append('limit', limit);

      const response = await apiCall(
        `${API_CONFIG.ENDPOINTS.REEL_VIDEO_INACTIVE}?${queryParams.toString()}`,
        { method: 'GET' }
      );
      return mapReelListResponse(response, limit);
    } catch (error) {
      console.error('Error fetching inactive reels:', error);
      throw error;
    }
  },

  // Reorder reels
  reorderReels: async (reorderData) => {
    try {
      const response = await apiCall(API_CONFIG.ENDPOINTS.REEL_VIDEO_REORDER, {
        method: 'PUT',
        body: JSON.stringify(reorderData)
      });
      return response;
    } catch (error) {
      console.error('Error reordering reels:', error);
      throw error;
    }
  },

  updateReel: async (reelId, updateData) => {
    try {
      const endpoint = `${API_CONFIG.ENDPOINTS.REEL_VIDEO_UPDATE}/${reelId}`;
      const response = await apiCall(endpoint, {
        method: 'PUT',
        body: JSON.stringify(updateData)
      });
      return response;
    } catch (error) {
      console.error('Error updating reel:', error);
      throw error;
    }
  },

  // Delete reel
  deleteReel: async (reelId) => {
    try {
      const endpoint = `${API_CONFIG.ENDPOINTS.REEL_VIDEO_DELETE}/${reelId}`;
      const response = await apiCall(endpoint, {
        method: 'DELETE',
      });
      return response;
    } catch (error) {
      console.error('Error deleting reel:', error);
      throw error;
    }
  },
};